module.exports = __webpack_public_path__ + "static/media/design.1e097bea.svg";